import React, { useState, useEffect, useMemo } from "react";
import Loader from "../../../components/Loader";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import PhotoGalleryRehab from "./PhotoGalleryRehab";
import VideoGalleryRehab from "./VideoGalleryRehab";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import {
  extractDateFromStr,
  getLatestDateFromData,
} from "../../../Utils/utils";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import RehabilitationPageTabs from "./RehabilitationPageTabs";
import useSeo from "../../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const RehabilitationPage = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: rehabilitationData = [], isLoading: RehabilitationIsLoading } =
    useGetProtectedApiDataQuery({
      url: "sustainable_development",
      lang: languageType,
    });

  // last updated on
  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(rehabilitationData);
  }, [rehabilitationData]);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    if (rehabilitationData.length > 0) {
      const lastElement = rehabilitationData[rehabilitationData.length - 1];
      setActiveTab(lastElement.title);
    }
  }, [rehabilitationData, languageType]);

  if (RehabilitationIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Sustainable Development", "सतत विकास")}
        titleLink="/sustainable-development/rehabilitation-and-resettlement"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            <div className="row mt-2">
              <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                <div className="innleft_section">
                  <ul className="menu nav nav-pills flex-column">
                    {rehabilitationData
                      .slice()
                      .reverse()
                      .map((item, index) => (
                        <li key={index} className="nav-item">
                          <a
                            href="#"
                            className={`nav-link ${
                              activeTab === item.title ? "active" : ""
                            }`}
                            onClick={(e) => {
                              e.preventDefault();
                              setActiveTab(item.title);
                            }}
                          >
                            <div
                              dangerouslySetInnerHTML={{ __html: item.title }}
                            ></div>
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-9 col-lg-9">
                {rehabilitationData?.map((item, index) => {
                  if (activeTab === item.title) {
                    switch (item.title) {
                      case "Photo Gallery":
                      case "फोटो गैलरी":
                        return <PhotoGalleryRehab key={index} data={item} />;
                      case "Video Gallery":
                      case "वीडियो गैलरी":
                        return <VideoGalleryRehab key={index} data={item} />;
                      default:
                        return (
                          <RehabilitationPageTabs
                            key={index}
                            data={item}
                            title={item.title}
                          />
                        );
                    }
                  }
                  return null;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RehabilitationPage;
